import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function PhoneContact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.305 4.942c-1.037 1.37.822 5.438 2.489 7.911a23.376 23.376 0 004.437 4.676c1.543 1.222 3.139 2.161 4.741 2.792 2.016.794 3.316.854 3.98.189l2.033-2.045c.034-.046.025-.366-.128-.677-.248-.508-.72-1.034-1.175-1.544-.226-.252-.448-.5-.646-.746-.212-.29-.357-.381-.427-.387a.96.96 0 00-.345.176l-2.003 2.015a1.008 1.008 0 01-1.115.212c-7.46-3.27-8.678-9.093-8.726-9.34a1.013 1.013 0 01.276-.912l1.068-1.074a1.01 1.01 0 00.295-.718c0-.27-.104-.523-.295-.716L6.34 3.322a1.004 1.004 0 00-1.424 0l-1.611 1.62zM17.627 23c-1.375 0-2.711-.526-3.388-.792-1.787-.703-3.556-1.743-5.254-3.087a25.388 25.388 0 01-4.841-5.106c-.835-1.236-4.79-7.428-2.37-10.392.021-.026.043-.05.066-.073l1.651-1.66a3.011 3.011 0 014.273 0L9.19 3.321a3.056 3.056 0 010 4.3l-.654.656c.422 1.284 1.966 4.754 6.796 7.094l1.482-1.49c.056-.061.814-.88 1.916-.793.503.03 1.243.259 1.903 1.176.144.176.344.398.546.624.523.583 1.114 1.245 1.486 2.002.513 1.046.433 2.203-.202 2.948l-2.086 2.103c-.792.797-1.78 1.058-2.75 1.058z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoPhoneContact = React.memo(PhoneContact);
export default MemoPhoneContact;